import { LogOut } from 'iconoir-react';
import React from 'react';
import { useIntl } from 'react-intl';
import { useAuth } from 'react-oidc-context';
import { useDispatch } from 'react-redux';

import { LANGUAGES } from '@savgroup-front-common/constants';
import {
  Menu,
  MenuItem,
  VERTICAL_MENU_ITEM_TYPES,
  VERTICAL_MENU_POSITIONS,
} from '@savgroup-front-common/core/atoms/Menu';
import {
  changeLocaleLanguage,
  setUserLanguagePreference,
} from '@savgroup-front-common/core/domains/i18n/actions';
import {
  LanguageIcon,
  RadioCheckedIcon,
  RadioUncheckedIcon,
} from '@savgroup-front-common/core/protons/icons';

import messages from './messages';

const HeaderProfileMenu = ({
  onClose,
  wrapperRef,
  isOpen,
}: {
  onClose: () => void;
  wrapperRef: React.RefObject<HTMLDivElement | null>;
  isOpen: boolean;
}) => {
  const items: MenuItem[] = [];
  const intl = useIntl();
  const dispatch = useDispatch();
  const languages = [LANGUAGES.FR, LANGUAGES.EN] as ('fr' | 'en')[];
  const auth = useAuth();
  const url = window.location.origin;
  const post_logout_redirect_uri = `${url}/index`;

  const handleChangeLanguage = (locale: LANGUAGES) => {
    dispatch(setUserLanguagePreference({ locale }));
    dispatch(changeLocaleLanguage({ locale }));
  };

  const languageSubmenu = languages.map<MenuItem>((language) => {
    const isCurrent = intl.locale === language;

    return {
      key: language,
      label: messages[language],
      type: VERTICAL_MENU_ITEM_TYPES.BUTTON,
      onClick: () => handleChangeLanguage(language as LANGUAGES),
      icon: isCurrent ? (
        <RadioCheckedIcon size="24px" />
      ) : (
        <RadioUncheckedIcon size="24px" />
      ),
    };
  });

  items.push({
    key: 'language',
    label: messages.languageLabel,
    type: VERTICAL_MENU_ITEM_TYPES.MENU,
    items: languageSubmenu,
    icon: <LanguageIcon />,
  });

  items.push({
    label: messages.logout,
    type: VERTICAL_MENU_ITEM_TYPES.BUTTON,
    icon: <LogOut width={24} height={24} />,
    key: 'logout',
    onClick: () => {
      auth.signoutRedirect({ post_logout_redirect_uri });

      sessionStorage.clear();
    },
    dataTestId: 'logoutButton',
  });

  return (
    <Menu
      key={String(isOpen)}
      onClose={onClose}
      wrapperRef={wrapperRef}
      isOpen={isOpen}
      position={VERTICAL_MENU_POSITIONS.RIGHT}
      menuItems={items}
    />
  );
};

export default HeaderProfileMenu;
